import React from "react";
import { Clock } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fmtDateTime } from "@/lib/api";

const Row = ({ label, iso, by, testId }) => (
  <div className="flex justify-between gap-3 py-1 border-b border-border last:border-b-0" data-testid={testId}>
    <span className="text-muted-foreground">{label}</span>
    <span className="text-right font-medium">{iso ? fmtDateTime(iso) : "—"}{iso && by ? <span className="block text-[10px] text-muted-foreground font-normal">{by}</span> : null}</span>
  </div>
);

// Tap the clock to see when a product was requested, bought, photographed and dropped off.
export const ProductTimeline = ({ item: it, T = (x) => x }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button type="button" className="inline-flex items-center justify-center w-6 h-6 rounded-full text-muted-foreground hover:text-foreground hover:bg-secondary"
        title={T("See times")} aria-label={T("See times")} data-testid={`shopping-times-btn-${it.id}`}>
        <Clock className="w-3.5 h-3.5" />
      </button>
    </PopoverTrigger>
    <PopoverContent collisionPadding={8} className="w-72 p-3 text-xs" data-testid={`shopping-times-${it.id}`}>
      <p className="font-semibold text-sm mb-1.5 truncate">{it.product}</p>
      <Row label={T("Requested")} iso={it.created_at} by={it.required_by_name} testId={`shopping-time-requested-${it.id}`} />
      <Row label={T("Bought")} iso={it.purchased_at} by={it.purchased_by} testId={`shopping-time-bought-${it.id}`} />
      <Row label={T("Photo taken")} iso={it.dropoff_photo_taken_at} testId={`shopping-time-photo-${it.id}`} />
      <Row label={T("Dropped off")} iso={it.dropoff_at} by={it.dropoff_by} testId={`shopping-time-dropoff-${it.id}`} />
    </PopoverContent>
  </Popover>
);
